import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'components/common';

const propTypes = {
  active: PropTypes.bool.isRequired,
  method: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    accountNumberLastFour: PropTypes.string.isRequired,
    institution: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    logoURL: PropTypes.string.isRequired,
  }).isRequired,
};

const PaymentMethod = ({ method, active }) => (
  <Container
    className="mb-1 items-center justify-end py-3 md:payments-methods-container md:pt-4 md:pb-5 md:mb-0 md:mx-2"
    heightFull={false}
  >
    <div className="flex justify-between w-full text-sm md:flex-col items-center md:text-center">
      <div className="md:mb-0 uppercase pr-1 md:mb-1 md:font-semibold md:order-1 md:pr-0">
        {method.logo && (
         <img alt="logo" className="inline-block md:block h-8 md:h-12 mr-2 md:mx-auto md:mb-2 border border-gray-200 rounded-full p-1" src={`data:image/png;base64,${method.logo}`} />
        )}
        {!method.logo && method.logoURL && (
         <img alt="logo" className="inline-block md:block h-8 md:h-12 mr-2 md:mx-auto md:mb-2 border border-gray-200 rounded-full p-1" src={`${method.logoURL}`} />
        )}
        <span className="self-center align-middle inline-block self-center pt-2px">{method.institution}</span>
      </div>
      {active && (
        <div className="uppercase text-gray-500 pr-1 md:order-0 md:pr-0 md:mb-2 inline-block self-center pt-2px text-xs">default</div>
      )}
      <div className="flex md:order-2">
        <div className="md:mb-1 text-gray-600 capitalize">{method.type}</div>
        <div className="md:mb-1 text-gray-600 pl-1 text-xs">(&hellip;{method.account_number_last_four})</div>
      </div>
    </div>
  </Container>
);

PaymentMethod.propTypes = propTypes;

export default PaymentMethod;
